import { PeekDialog, PeekDialogContent } from "@piiqtechnologies/ui-components";
import React from "react";
import { useIntl } from "react-intl";
import FloorplanEditor from "./FloorplanEditor";
import messages from "./messages.i18n";
export const FloorplanEditorDialog = ({ open, imageUrl, onClose, onSave, onCancel, }) => {
    const intl = useIntl();
    const handleSave = (editedImageDataUrl) => {
        onSave(editedImageDataUrl);
        onClose();
    };
    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
        onClose();
    };
    return (React.createElement(PeekDialog, { open: open, onClose: handleCancel, title: intl.formatMessage(messages.editFloorplanTitle), hasCloseIcon: true, maxWidth: false, fullWidth: true, PaperProps: {
            sx: {
                width: "100vw",
                height: "100vh",
                maxWidth: "100vw",
                maxHeight: "100vh",
                margin: 0,
                borderRadius: 0,
            },
        } },
        React.createElement(PeekDialogContent, { sx: { p: 0, height: "100%", display: "flex", flexDirection: "column" } },
            React.createElement(FloorplanEditor, { imageUrl: imageUrl, onSave: handleSave, onCancel: handleCancel }))));
};
export default FloorplanEditorDialog;
